"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Decorator = void 0;
var tslib_1 = require("tslib");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
exports.Decorator = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var templateObject_1;
//# sourceMappingURL=decorator.js.map